import PracticeAnalyticsPage from '../../js/pages/PracticeAnalyticsPage';
import {withAdminRole} from '../../js/components/Routes';

export default withAdminRole(PracticeAnalyticsPage);
